import React from 'react';
import '../../Hero.css';

function SkillsDescription() {
  return (
    <div className="hero-top">
      <h1>
        My <span className="highlight">Skills</span>
      </h1>
      <p className="page-subtitle">
        Languages, frameworks, and platforms I use to ship full-stack and AI work.
      </p>
    </div>
  );
}

export default SkillsDescription;
